import { Injectable, signal } from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MapLoader {
  private loading = false;

  loaded = signal(false);

  public options: google.maps.MapOptions = {
    mapId: environment.googleMapsMapId,
    center: {lat: 39.8097343, lng: -98.5556199},
    zoom: 4.3,
    mapTypeId: 'roadmap',
    disableDefaultUI: true,
    gestureHandling: 'greedy'
  };

  init(): void {
    if (this.loaded() || this.loading) {
      return;
    }

    this.loading = true;
    const script = document.createElement('script');
    const params = new URLSearchParams({
      key: environment.googleMapsApiKey,
      v: 'weekly',
      libraries: 'marker',
      callback: 'initMap',
      language: 'en',
      loading: 'async'
    });

    script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
    script.async = true;
    script.defer = true;

    (window as any).initMap = () => {
      this.loading = false;
      this.loaded.set(true);
    }

    script.onerror = () => {
      this.loading = false;
    }

    document.body.appendChild(script);
  }
}
